<div>
  <p-treeTable [value]="optionsData" showGridlines (onNodeExpand)="toggleReference($event)"
               (onNodeCollapse)="toggleReference($event)">
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [ngStyle]="{'width': col.width}" [ngClass]="col.styleClass">
          <button *ngIf="toExpand && col.label ==='T_COMPONENT_REFERENCE_COLUMN'"
                  class="btn btn-default-white-background collapse-button pi pi-angle-right"
                  (click)="toggleExpand()"></button>
          <button *ngIf="!toExpand && col.label ==='T_COMPONENT_REFERENCE_COLUMN'"
                  class="btn btn-default-white-background collapse-button pi pi-angle-down"
                  (click)="toggleExpand()"></button>
          <span>{{ col.label | translate }}</span>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
      <tr [ttRow]="rowNode">
        <td [class]="{ 'td-value': rowNode.node.parent !== null}">
          <div class="flex items-center gap-2">
            <div class="option-name">
              <p-treeTableToggler [rowNode]="rowNode" *ngIf="rowNode.node.type === 'component'"/>
              <span class="option-name-title" translate>{{ rowData.componentReference }}</span>
            </div>
            <div *ngIf="isExpanded(rowNode)" class="description-option" translate>{{ rowData.componentDescription }}
            </div>
          </div>
        </td>
        <td>
          <div class="option-category expandable">
            <p-treeTableToggler [rowNode]="rowNode" *ngIf="rowNode.node.type === 'category'"/>
            <div class="option-category-name">
              {{ rowData.categoryName | translate }}
            </div>
            <div class="buttons-actions" *ngIf="rowNode.node.type === 'category'">

              <button class="btn action-button pi pi-pencil" *ngIf="isNoCategory(rowData)"  (click)="onClickEditCategoryButton(rowNode)"></button>
              <button class="btn action-button pi pi-link"
                      (click)="onClickEditCategoryAssociationButton(rowNode)"></button>
              <span [style.cursor]="rowData.category === '-' ? 'not-allowed' : 'pointer'">
                <button class="btn action-button pi pi-trash" *ngIf="isNoCategory(rowData)"
                        [style.pointer-events]="rowData.category === '-' ? 'none' : 'auto'"
                        (click)="onClickDeleteCategoryButton(rowNode)"></button>
              </span>
              <ng-container *ngIf="isNoCategory(rowData)">
                <button [disabled]="isCategoryFirst(rowNode)" class="btn action-button se-icon icon-big"
                        (click)="onChangeCategoryOrder('up', rowNode)">
                  arrow3_up
                </button>
                <button [disabled]="isCategoryLast(rowNode)" class="btn action-button se-icon icon-big"
                        (click)="onChangeCategoryOrder('down', rowNode)">
                  arrow3_down
                </button>
              </ng-container>
            </div>
          </div>
          <span *ngIf="rowData.category !== null && rowData.category !== undefined && rowData.category !== '-'"
                class="option-category-id">id: {{ rowData.category }}</span>
        </td>
        <td>
          <div class="option-name expandable">
            <p-treeTableToggler [rowNode]="rowNode" *ngIf="rowNode.node.type === 'option'"/>
            <span class="option-name-title" translate>{{ rowData.name }}</span>
            <div class="buttons-actions" *ngIf="rowNode.node.type === 'option'">
              <button
                class="btn action-button se-icon icon-big"
                [disabled]="!canMoveUp(rowNode)"
                (click)="onChangeOptionOrder('up', rowNode); $event.stopPropagation()">
                arrow3_up
              </button>
              <button
                class="btn action-button se-icon icon-big"
                [disabled]="!canMoveDown(rowNode)"
                (click)="onChangeOptionOrder('down', rowNode); $event.stopPropagation()">
                arrow3_down
              </button>
            </div>
          </div>
        </td>
        <td [class]="{ 'td-value': rowNode.node.parent !== null}">
          <div class="flex items-center gap-2">
            <div class="option-name">
              <span class="option-name-title" translate>{{ rowData.valueName }}</span>
            </div>
          </div>
        </td>
        <td>{{ rowData.reference }}</td>
      </tr>

    </ng-template>
  </p-treeTable>

</div>

<app-odm-edit-category-modal #editCategoryModal
                             [selectedRange]="selectedRange"
                             [selectedCategoryId]="selectedCategoryId"
                             (saveOption)="editCategoryName($event)">
</app-odm-edit-category-modal>


<app-odm-edit-category-assignation-modal #editCategoryAssignationModal
                                         [selectedRange]="selectedRange"
                                         [selectedCategoryId]="selectedCategoryId"
                                         (saveOptionCategory)="editCategoryAssociation($event)">
</app-odm-edit-category-assignation-modal>

